import { render, staticRenderFns } from "./csInvoices.vue?vue&type=template&id=54fe4d55&scoped=true"
import script from "./csInvoices.vue?vue&type=script&lang=js"
export * from "./csInvoices.vue?vue&type=script&lang=js"
import style0 from "./csInvoices.vue?vue&type=style&index=0&id=54fe4d55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fe4d55",
  null
  
)

export default component.exports